<template>
    <div style="    position: relative;">
        <b-form-input :id="idFor" :type="passwordType" placeholder="Password" autocomplete v-model="inputValue" required @input="updateData">

        </b-form-input>
        <b-btn @click="toggleShow" class="show-password-btn eye-password">
            <eye-icon class="icon-default eye-icon">
            </eye-icon>
        </b-btn>

    </div>

</template>

<script>
import EyeIcon from '../../assets/eye.svg';
export default {
  name: 'PasswordInput',
  props: ['idFor', 'value'],
  components: {
    EyeIcon
  },
  data() {
    return {
      passwordType: 'password',
      inputValue: ''
    };
  },
  watch:{
    value(newVal,oldVal){
      this.inputValue = this.value;
    }
  },
  created() {
    this.inputValue = this.value;
  },
  methods: {
    updateData() {
      this.$emit('input', this.inputValue);
    },
    toggleShow() {
      if (this.passwordType == 'text') {
        this.passwordType = 'password';
        return;
      }
      this.passwordType = 'text';
    }
  }
};
</script>

<style scoped>
.btn {
  position: absolute;
  top: 6px;
  right: 4px;
  background: none !important;
  border: none !important;
}
</style>
